
import Timeout from '@derpierre65/vue-utils/src/mixins/Timeout'
import search from '../../assets/search.json'
import AlertDetailsModal from '../default/AlertDetailsModal'
import OverlayDetailsModal from '../default/OverlayDetailsModal'
import AppTabMenu from '../AppTabMenu'
import SearchProductList from './search/SearchProductList'

export default {
  name: 'TheSearch',
  components: { AppTabMenu, OverlayDetailsModal, AlertDetailsModal, SearchProductList },
  mixins: [Timeout],
  data () {
    return {
      searchValue: '',
      currentSearch: '',
      activeTab: 'overlays',
      matches: null,
      showSuggestions: false,
      showLoading: false,
      alertPreviewId: null,
      themePreview: null
    }
  },
  computed: {
    tabMenuItems () {
      const items = []

      if (this.matches.themes.length) {
        items.push({ name: 'overlays', title: this.$t('dashboard.search.types.themes') })
      }

      if (this.matches.alerts.length) {
        items.push({ name: 'alerts', title: this.$t('dashboard.search.types.alerts') })
      }

      if (this.matches.dashboard.length) {
        items.push({ name: 'dashboard', title: this.$t('dashboard.search.types.dashboard') })
      }

      return items
    }
  },
  watch: {
    searchValue () {
      this.setTimeout(this.search, process.env.SEARCH_DEBOUNCE_VALUE, 'debounce')
    },
    $route () {
      this.showSuggestions = false
    }
  },
  mounted () {
    document.addEventListener('keyup', this.focusSearch)

    try {
      this.searchValue = window.localStorage.getItem('search')
    } catch (e) {
      // do nothing, this appear if the user has a browser without localStorage or the localStorage is disabled
    }
  },
  destroyed () {
    document.removeEventListener('keyup', this.focusSearch)
  },
  methods: {
    focusSearch (event) {
      if (event.key?.toLowerCase() === 'f' && !document.querySelector(':focus')) {
        this.focus()
      }
    },
    focus () {
      this.$nextTick(() => {
        this.$refs.search.focus()
      })
    },
    hide () {
      this.showSuggestions = false
    },
    search () {
      this.clearTimeout('debounce')
      const searchValue = (this.searchValue || '').trim().toLowerCase()

      if (!searchValue.length || searchValue === this.currentSearch) {
        return
      }

      this.currentSearch = searchValue
      this.showLoading = true
      let matches = {
        dashboard: [],
        themes: [],
        alerts: []
      }

      if (window.localStorage) {
        window.localStorage.setItem('search', searchValue)
      }

      for (const searchable of search) {
        const matchData = {
          icon: searchable.icon,
          route: searchable.route
        }

        let title = ''

        if (searchable.title) {
          title = this.$t(searchable.title)

          if (title && title.toLowerCase().includes(searchValue)) {
            matches.dashboard.push({
              title,
              ...matchData
            })

            continue
          }
        }

        for (const keyword of searchable.keywords || []) {
          const translation = this.$t(keyword)

          if (translation.toLowerCase().includes(searchValue)) {
            matches.dashboard.push({
              title,
              keyword: translation,
              ...matchData
            })

            if (matches.dashboard.length >= 5) {
              break
            }
          }
        }

        if (matches.dashboard.length >= 5) {
          break
        }
      }

      this.$axios
        .get('v1/dashboard/search/', {
          params: {
            q: searchValue
          }
        })
        .then(({ data }) => {
          matches = {
            ...matches,
            ...data
          }
        })
        .catch(() => {
          this.$toast.error(this.$t('dashboard.search.search_fail'))
        })
        .finally(() => {
          this.showLoading = false
          this.matches = matches

          if (matches.themes.length) {
            this.activeTab = 'overlays'
          } else if (matches.alerts.length) {
            this.activeTab = 'alerts'
          } else if (matches.dashboard.length) {
            this.activeTab = 'dashboard'
          }
        })
    }
  }
}
